import React from 'react';
import { motion } from 'framer-motion';
import { Flame } from 'lucide-react';
import { DjayGrowthState } from '../../shared/DjayGrowthState';
import { GrowthStage } from '../../../mastery';
import { RADIUS } from '../../../config/designTokens';
interface JourneyTrailheadProps {
  overallGrowthStage: GrowthStage;
  overallMastery: number;
  currentStreak: number;
}
export function JourneyTrailhead({
  overallGrowthStage,
  overallMastery,
  currentStreak
}: JourneyTrailheadProps) {
  return <div className="flex flex-col items-center text-center pt-8 pb-12 relative z-10" data-id="element-1980" data-mp="p5bkvl8wla1i">
      <motion.div initial={{
      scale: 0.8,
      opacity: 0,
      y: 20
    }} animate={{
      scale: 1,
      opacity: 1,
      y: 0
    }} transition={{
      type: 'spring',
      bounce: 0.5
    }} className="relative mb-6" data-id="element-1981" data-mp="kev720167mem">
        
        <div className="absolute inset-0 bg-amber-200 blur-3xl opacity-30 rounded-full" data-id="element-1982" data-mp="1cw7jb17v73hq" />

        <div className={`bg-white border-4 border-amber-100 p-4 ${RADIUS.card} shadow-xl relative z-10 flex flex-col items-center gap-3`} data-id="element-1983" data-mp="183o3rypm9yaa">
          
          <div className="flex items-center gap-3" data-id="element-1984" data-mp="2cymofafgffr1">
            <div className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center border-2 border-amber-200 shadow-inner" data-id="element-1985" data-mp="2cxco0el4pvh8">
              <DjayGrowthState masteryScore={overallMastery} size="lg" data-id="element-1986" data-mp="1z5ev9ebq6c78" />
            </div>
            <div className="text-left" data-id="element-1987" data-mp="2447xgalkags3">
              <p className="text-sm font-bold text-slate-400 uppercase tracking-wider" data-id="element-1988" data-mp="1p8jyazv3ojv2">
                Jouw groei
              </p>
              <h1 className="text-2xl sm:text-3xl font-black text-slate-800" data-id="element-1989" data-mp="1u9ptd4c8gj7r">
                {overallGrowthStage.label}
              </h1>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Campfire Streak */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="flex flex-col items-center gap-2" data-id="element-1990" data-mp="1l9b4xw3z2o01">
        
        <div className="relative w-16 h-16 flex items-center justify-center" data-id="element-1991" data-mp="3fkptwap5sjeq">
          <motion.div animate={{
          scale: [1, 1.1, 0.95, 1.05, 1],
          rotate: [-2, 3, -1, 2, 0]
        }} transition={{
          repeat: Infinity,
          duration: 2,
          ease: 'easeInOut'
        }} className="absolute inset-0 bg-orange-500/20 blur-xl rounded-full" data-id="element-1992" data-mp="3d7m5atv37i38" />
          
          <Flame className="w-10 h-10 text-orange-500 relative z-10 drop-shadow-md" fill="currentColor" data-id="element-1993" data-mp="2z8mfhivu8x5h" />
          
        </div>
        <div className="bg-orange-100 text-orange-800 px-4 py-1.5 rounded-full text-sm font-black shadow-sm border border-orange-200" data-id="element-1994" data-mp="r8o51gz4kva">
          {currentStreak} dagen op rij
        </div>
      </motion.div>
    </div>;
}